export default "__VITE_ASSET__rdSrzugf__"